exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-pagination {\n  margin-top: 20px;\n  text-align: right;\n}\n.table-wrap .action-icon {\n  cursor: pointer;\n  color: #409eff;\n  margin-left: 10px;\n}\n.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {\n  right: 10px;\n}\n", ""]);

// exports
